import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Dev-only preview harnesses (gated on NODE_ENV so they never reach the
// deployed bundle): `?account-preview`, `?auth-preview`, `?cart-preview`,
// `?purchase-success-preview`, `?download-started-preview`.
const AccountPreview = React.lazy(() => import('./dev/AccountPreview'));
const AuthPreview = React.lazy(() => import('./dev/AuthPreview'));
const CartPreview = React.lazy(() => import('./dev/CartPreview'));
const PurchaseSuccessPreview = React.lazy(() => import('./dev/PurchaseSuccessPreview'));
const DownloadStartedPreview = React.lazy(() => import('./dev/DownloadStartedPreview'));
const params = new URLSearchParams(window.location.search);
const isDev = process.env.NODE_ENV === 'development';
const showAccountPreview = isDev && params.has('account-preview');
const showAuthPreview = isDev && params.has('auth-preview');
const showCartPreview = isDev && params.has('cart-preview');
const showPurchaseSuccessPreview = isDev && params.has('purchase-success-preview');
const showDownloadStartedPreview = isDev && params.has('download-started-preview');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
function Root() {
  if (showAccountPreview) return <AccountPreview />;
  if (showAuthPreview) return <AuthPreview />;
  if (showCartPreview) return <CartPreview />;
  if (showPurchaseSuccessPreview) return <PurchaseSuccessPreview />;
  if (showDownloadStartedPreview) return <DownloadStartedPreview />;
  return <App />;
}

root.render(
  <React.StrictMode>
    <React.Suspense fallback={null}>
      <Root />
    </React.Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
